import React, { Component } from 'react';
import { OURS_KEY } from './unreconciled_data';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { Spin, Empty, Pagination, Tag, Modal, Button, Select, Tooltip, Icon, Badge, Table } from 'antd';
import { showErrorInNotification, formatMoney, showSuccessInNotification } from '../../lib/util';
import ModalTransactionDetail from '../../components/modal_transaction_detail';
import { TransactionReconcileItem } from '../../components/transaction_reconcile_item';
import { FilterListOutlined, SyncAltRounded, RefreshOutlined, ExpandMoreOutlined, ExpandLessOutlined } from '@material-ui/icons';
import { COLORS } from '../theme';
import { CustomSwitch, CustomButton } from '../../components/basic_items';
import { PopUpForm } from '../../lib/ui/popupform';

class RecommendedReconcilerList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      type: props.type,
      selected: false,
      selectedID: null,
      selectedSplitTxnID: null,
      list_data: [],
      list_meta: {},
      filterVisible: false,
      filter_query: {
        per_page: 20,
        page: 1,
        rule_id: props.rule_id,
        tran_id: props.tran_id,
        source_id: this.props.source_id
      },
      error: false,
      loading: true,
      hasFilter: false
    };



    this.splitTransaction = RESTExecutor.post().config({
      label: 'split_unreconciled'
    }).callbacks((success) => {
      this.setState({
        selectedSplitTxnID: null,
        selectedID: null
      })
      this.list_recommended.execute();
      showSuccessInNotification(success, "Transaction Split Successful");
    }, (error) => {

    }).connect(props.domains.reconciliation)

    this.list_recommended = RESTExecutor.list().config({
      label: 'recommended_for_rules',
      params: {
        ...this.state.filter_query
      }
    }).callbacks((success) => {
      this.setState({ list_data: success.result.rows, loading: false, list_meta: success.meta })
    }, (error) => {
      this.setState({ error: true })
      showErrorInNotification(error);
    }).connect(props.domains.reconciliation);




  };



  getRecommendation = (tran_id) => {
    console.log("getting recommendattion for", tran_id)
    if (tran_id) {


      let params = this.props.rule_id != null ? {
        rule_id: this.props.rule_id,
        tran_id: tran_id,
      } : {
        reconciler_id: this.props.reconciler_id,
        tran_id: tran_id,
      };

      this.setState({
        selected: true,
        loading: true,
        error: false,
        selectedTranId: tran_id,
        selectedID: null,
        list_data: [],
        list_meta: {},
        filter_query: {
          ...this.state.filter_query,
          per_page: 20,
          page: 1,
          source_id: this.props.source_id,
          ...params
        }
      }, () => {

        this.list_recommended.config({
          label: this.props.rule_id != null ? 'recommended_for_rules' : 'recommended_for_unclassified',
          params: {
            ...this.state.filter_query
          }
        }).execute()
      })
    } else {
      this.setState({
        selected: false,
        selectedID: null,
        list_data: [],
        list_meta: {},
      });
    }
  }



  getParams = () => {
    let params = JSON.parse(JSON.stringify(this.state.filter_query));

    return params;
  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }


  render() {
    const { selected, selectedID, loading, list_data, list_meta, filterVisible, filter_query, hasFilter } = this.state;
    let rowData = list_data;
    let rowMeta = list_meta || {};
    let list_recommended_resp = this.list_recommended.response();


    return (
      <div style={{ width: '60%', boxShadow: COLORS.unreconciled_box_shadow }}>

        <PopUpForm
          forCreate={true}
          show_title_only
          title="Split Transaction"
          open={!!this.state.selectedSplitTxnID}
          onClose={() => {
            this.setState({
              selectedSplitTxnID: null
            })
          }}
          initialData={this.state.splitData}
          networkState={this.splitTransaction.response()}
          fields={[
            {
              name: "Amount to Split",
              index: 'amount',
              placeholder: "Amount to Split",
              type: 'number',
              required: true
            }
          ]}
          onSubmit={(data) => {
            this.splitTransaction.execute({
              ...data,
              txn_id: this.state.selectedSplitTxnID
            })
          }}
        />

        <Modal
          visible={this.state.view_transaction_modal}
          width={'90%'}
          destroyOnClose
          footer={null}
          centered
          className='transaction-modal'
          onCancel={() => {
            this.setState({
              view_transaction_modal: false,
              view_transaction_id: null
            })
          }}
        >
          <ModalTransactionDetail
            onClose={() => {
              this.setState({
                view_transaction_modal: false,
                view_transaction_id: null
              })
            }}
            isModal={true}
            match={{
              params: {
                transaction_id: this.state.view_transaction_id
              }
            }}
          />
        </Modal>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          height: '100%',
          justifyContent: 'space-between'
        }}>

          <div className='unreconciled-top' style={{
            padding: 8,
            backgroundColor: COLORS.white,
            boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.25)',
            zIndex: 9
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'row-reverse',
              alignItems: 'center',
              paddingTop: 0,
              paddingBottom: 20
            }}>
              {this.props.toggleRender}
              {/* <span className='sub-heading-3'>THEIRS</span>
                &nbsp;&nbsp;&nbsp;
                <span className='heading-2' style={{
                  color:COLORS.primary
                }}>SCB INR Ledger (NMB)</span>
                &nbsp;&nbsp;&nbsp;
                <SyncAltRounded titleAccess="Switch OURS and THEIRS" className='toggle-icon hand-cursor' />
             */}
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              flexWrap: 'wrap'
            }}>
              {!selected ? <div></div> : <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}>
                <div className='hand-cursor'
                  onClick={() => {
                    this.setState({
                      filterVisible: !filterVisible
                    })
                  }}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                  }}>
                  <FilterListOutlined className='filter-icon' style={{
                    color: hasFilter ? COLORS.success_primary : null
                  }} />
                  &nbsp;
                  {filterVisible ? "Hide" : "Show"} Filters
                  {filterVisible ?
                    <ExpandLessOutlined />
                    :
                    <ExpandMoreOutlined />}
                </div>

                &nbsp;
                {/* <Dropdown overlay={sort_menu} trigger={['click']} placement='bottomRight'>
              <a className="ant-dropdown-link" href="#">
                Sort By <Icon type="down" />
              </a>
            </Dropdown> */}
                <RefreshOutlined style={{
                  marginLeft: 20
                }} titleAccess='Refresh' onClick={() => {
                  this.setState({
                    selectedID: null,
                    loading: true
                  });
                  typeof this.props.onSelectedID === 'function' && this.props.onSelectedID(null);
                  this.list_recommended.execute();
                }} className='menu-icon main-icon hand-cursor' />

              </div>}
              {typeof this.props.onToggle === 'function' && <CustomSwitch
                title="Switch between Recommended and Manual"
                value={this.props.currentMode}
                trueItem="Recommended"
                falseItem="Manual"
                onChange={(value) => {
                  this.props.onToggle()
                }}
              />}
            </div>
            {filterVisible && <div><div style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              paddingTop: 20
            }}>


              <Select
                allowClear
                showSearch
                className={filter_query.txn_type ? 'filter-option-selected' : ''}
                style={{
                  marginTop: 0,
                  marginBottom: 10,
                  marginRight: 10,
                  width: 200
                }}
                placeholder="Type"
                value={filter_query.txn_type}
                // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onChange={(value, e) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'txn_type',
                    value: value,
                  });
                }}
              >
                <Select.Option value={"D"} key={"D"}>
                  Debit
                </Select.Option>
                <Select.Option value={"C"} key={"C"}>
                  Credit
                </Select.Option>
                <Select.Option value={"N/A"} key={"N/A"}>
                  N/A
                </Select.Option>
              </Select>
            </div>
              <div style={{ display: 'flex', flexDirection: 'row', paddingTop: 8, paddingBottom: 8 }}>
                <CustomButton
                  className='primary-btn'
                  onClick={() => {
                    this.setState({
                      selectedID: null,
                      loading: true,
                      hasFilter: true
                    })
                    typeof this.props.onSelectedID === 'function' && this.props.onSelectedID(null);
                    this.list_recommended.config({
                      params: {
                        ...this.getParams()
                      }
                    }).execute()
                  }}
                  label="FILTER"
                />
              </div>
            </div>}
          </div>
          <div style={{
            overflowY: 'scroll',
            // flex:1,
            height: '100%',
            padding: '0px 10px 0px 12px',
            backgroundColor: 'rgba(0,0,0,0.02)'
          }}>
            {!selected ? <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%'
            }}>
              <center>
                <Tag>Please select transaction from left to get recommendation</Tag></center>
            </div> :
              <Table
                loading={list_recommended_resp.fetching}
                className='padding-top-table main-table no-separator-table no-lr-padding-table unreconciled-table  '
                style={{
                  // backgroundColor:'inherit'
                }}
                showHeader={false}
                locale={{
                  emptyText: this.state.error ? <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    height: '100%',
                    minHeight: 300
                  }}>
                    <center>
                      <Tag>There was some error fetching recommendations.
                        <Button onClick={() => {
                          this.setState({
                            error: false,
                            loading: true
                          });
                          this.list_recommended.execute()
                        }} type='link'>Try Again</Button>
                      </Tag></center>
                  </div> : null
                }}
                pagination={{
                  size: 'small',
                  onChange: (current, size) => {
                    console.log(current, size);
                    this.setState({
                      selectedID: null,
                      pageLoading: true
                    });
                    typeof this.props.onSelectedID === 'function' && this.props.onSelectedID(null)
                    this.stateUpdater({
                      stateKey: 'filter_query',
                      appendObj: {
                        per_page: size,
                        page: current
                      },
                      callback: () => {
                        console.log("calling")
                        this
                          .list_unreconciled_data
                          .config({
                            params: {
                              ...this.getParams(),
                            }
                          })
                          .execute();
                      }
                    });

                  },
                  defaultCurrent: 1,
                  current: rowMeta.pagination && parseInt(rowMeta.pagination.split('/')[0]),
                  pageSize: (rowMeta && rowMeta.requested_count),
                  total: (rowMeta && rowMeta.total_count),
                  showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${formatMoney(total, 0)} items`,
                }}
                dataSource={rowData}
                columns={[
                  {
                    key: 'tab',
                    render: (record, data, index) => {
                      return <TransactionReconcileItem
                        onSplit={() => {
                          this.setState({
                            selectedSplitTxnID: record.txn_id
                          })
                        }}
                        reconcile_btn={this.props.reconcile_btn}
                        isSelectable
                        item_type='recommended'
                        // comparator_renderer={this.props.comparator_renderer}
                        selectedID={selectedID}
                        itemID={record.id}
                        onViewDetailClicked={(id) => {
                          this.setState({
                            view_transaction_id: id,
                            view_transaction_modal: true
                          })
                        }}
                        onSelected={(id, data) => {
                          this.setState({ selectedID: id }, () => {
                            typeof this.props.onSelectedID === 'function' && this.props.onSelectedID(id, data, index)
                          })
                        }}
                        data={record}
                        key={index} />


                    }
                  }
                ]}
              />

            }



          </div>


        </div>



      </div>
    );
  }

  componentDidMount() {

    typeof this.props.onRef === 'function' && this.props.onRef(this);

  }
  componentWillUnmount() {

    typeof this.props.onRef === 'function' && this.props.onRef(undefined);
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.tran_id != null) {
      this.setState({
        selected: false,
        selectedID: null
      })
    }
    else if (this.props.tran_id !== prevProps.tran_id) {
      this.setState({
        loading: true,
      })


      // fetch the new product based and set it to the state of the component
    };
  };


}

export default withDomains(RecommendedReconcilerList, "reconciliation", "allData");
